import { render } from "./TopCategoriesList.vue?vue&type=template&id=776ce12d&ts=true"
import script from "./TopCategoriesList.vue?vue&type=script&lang=ts"
export * from "./TopCategoriesList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/product-category-selector/tabs/TopCategoriesList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "776ce12d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('776ce12d', __exports__)) {
    api.reload('776ce12d', __exports__)
  }
  
  module.hot.accept("./TopCategoriesList.vue?vue&type=template&id=776ce12d&ts=true", () => {
    api.rerender('776ce12d', render)
  })

}


export default __exports__